export const getConnectedFileExtension = (fileExt: string) => {
  if (fileExt?.includes("google_drive")) {
    return "Google Drive";
  }
  if (fileExt?.includes("teamwork_cloud")) {
    return "Teamwork Cloud";
  }
  if (fileExt?.includes("windchill")) {
    return "Windchill";
  }
  if (fileExt?.includes("3d_experience")) {
    return "3DEXPERIENCE";
  }
  if (fileExt?.includes("microsoft_365")) {
    return "Microsoft 365";
  }
  return fileExt;
};

export const getFileNameAndExtension = (fileName: string | null | undefined) => {
  if (!fileName) {
    return null;
  }
  const trimInd = fileName.lastIndexOf(".") ?? fileName.length;
  return {
    extension: fileName.substring(trimInd + 1, fileName.length),
    name: fileName.substring(0, trimInd),
  };
};

export const checkIsLinkedModel = (extension: string | undefined): boolean => {
  if (!extension) {
    return false;
  }
  return extension.startsWith("istari") && extension.includes("metadata");
};

export const getLiteralModelName = (extension: string | undefined): string | undefined => {
  switch (extension) {
    case "catpart":
    case "catproduct":
      return "Catia";
    case "mdzip":
      return "Cameo";
    case "xlsx":
      return "Excel";
    default:
      return getConnectedFileExtension(extension!);
  }
};

export const getExtractableFileType = (extension: string): string => {
  switch (extension) {
    case "catpart":
    case "catproduct":
      return "catia";
    case "docx":
      return "word";
    case "mdzip":
      return "cameo";
    case "xlsx":
    case "csv":
      return "excel";
    default:
      return extension;
  }
};

export const getAppHostFromExt = (ext: string | null | undefined) =>
  ext ? ext.match(/istari_(.*)_metadata.*/)?.[1] : undefined;
